"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingRewardTokenType = exports.StakingDepositTokenType = exports.StakingRuleStatus = void 0;
var StakingRuleStatus;
(function (StakingRuleStatus) {
    StakingRuleStatus["NEW"] = "NEW";
    StakingRuleStatus["ACTIVE"] = "ACTIVE";
    StakingRuleStatus["INACTIVE"] = "INACTIVE";
})(StakingRuleStatus || (exports.StakingRuleStatus = StakingRuleStatus = {}));
var StakingDepositTokenType;
(function (StakingDepositTokenType) {
    StakingDepositTokenType["NATIVE"] = "NATIVE";
    StakingDepositTokenType["ERC20"] = "ERC20";
    StakingDepositTokenType["ERC721"] = "ERC721";
    StakingDepositTokenType["ERC998"] = "ERC998";
    StakingDepositTokenType["ERC1155"] = "ERC1155";
})(StakingDepositTokenType || (exports.StakingDepositTokenType = StakingDepositTokenType = {}));
var StakingRewardTokenType;
(function (StakingRewardTokenType) {
    StakingRewardTokenType["NONE"] = "NONE";
    StakingRewardTokenType["NATIVE"] = "NATIVE";
    StakingRewardTokenType["ERC20"] = "ERC20";
    StakingRewardTokenType["ERC721"] = "ERC721";
    StakingRewardTokenType["ERC998"] = "ERC998";
    StakingRewardTokenType["ERC1155"] = "ERC1155";
    StakingRewardTokenType["MYSTERY"] = "MYSTERY";
})(StakingRewardTokenType || (exports.StakingRewardTokenType = StakingRewardTokenType = {}));
//# sourceMappingURL=rule.js.map